import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RESTServiceV2 } from 'src/app/shared/services/rest.service.v2';

export type FaproAuditType = 'open' | 'cancel' | 'bannerClick';

@Injectable({
  providedIn: 'root',
})
export class AuditLogService {
  constructor(private restV2: RESTServiceV2) {}

  create(faproType: FaproAuditType): Observable<any> {
    return this.restV2.post(`/audit-log/fapro`, {
      faproType,
    });
  }
}
